/**
 * @generated SignedSource<<22a83468054efd497a35258d90f21d7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MenuItemType = "ARTICLES" | "EXTERNAL" | "PACKAGES" | "PAGE";
import { FragmentRefs } from "relay-runtime";
export type MenuItemsListRow_menuItem$data = {
  readonly id: string;
  readonly name: string;
  readonly type: MenuItemType | null;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "MenuItemsListRow_menuItem";
};
export type MenuItemsListRow_menuItem$key = {
  readonly " $data"?: MenuItemsListRow_menuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemsListRow_menuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MenuItemsListRow_menuItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "MenuItem",
  "abstractKey": null
};

(node as any).hash = "b039d65cbea66162b89a301afb75d6da";

export default node;
